import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// barcode scanner
import BarcodeScannerComponent from "react-qr-barcode-scanner";

// custom components
import { CustomSpinner } from '_atoms';
import { FormBookingCard, CustomModal } from '_molecules';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { resetScanFlags, selectScannedBooking, createBooking, selectScannedBookingStatus, patchBooking, selectPatchBookingStatus, deleteBooking, selectDeleteBookingStatus, selectDeleteBookingError, selectPatchBookingError, selectScannedBookingError } from '_redux/slices/timeline/flight-scanner';

// bootstrap
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';


// exterior libraries
import { Title as TremorTitle, Subtitle, Flex } from '@tremor/react';

// styles 
import { Spacing, Colors } from '_styles';

// icons
import { MdQrCode2 } from "react-icons/md";
import { IoCloseCircle } from "react-icons/io5";
import { selectIata } from '_redux/slices/main-screen/user';

const FlightScanner = (props) => {

    // nav
    const history = useHistory();
    const location = useLocation()
    // local states
    const [hasPermission, setHasPermission] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [streamToggle, setStreamToggle] = useState(false);
    const [barcodeError, setBarcodeError] = useState(false);
    const [submitted, setSubmitted] = useState(false);              // true if booking has been submitted to be created
    const [loading, setLoading] = useState(false);

    const [showBooking, setShowBooking] = useState(false);          // true if booking has been created and should be displayed

    // modal
    const [successModal, setSuccessModal] = useState(false);
    const [deletedModal, setDeletedModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState('');

    // redux
    const dispatch = useDispatch();

    const scannedBooking = useSelector(selectScannedBooking);
    const bookingStatus = useSelector(selectScannedBookingStatus);
    const bookingError = useSelector(selectScannedBookingError);
    // const patchError = false;

    const patchStatus = useSelector(selectPatchBookingStatus);
    const patchError = useSelector(selectPatchBookingError);
    const iata = useSelector(selectIata);                                       // holds iata of account

    const deletedStatus = useSelector(selectDeleteBookingStatus);
    const deleteError = useSelector(selectDeleteBookingError);


    // patch status listener
    useEffect(() => {
        // complete
        if (deletedStatus == 'succeeded' && submitted) {
            setLoading(false)
            console.log('successfully deleted booking')
            // close scanner
            setDeletedModal(true)
        }
        if (deletedStatus == 'loading' && submitted) {
            setLoading(true)
            console.log('deleting booking loading...')
        }
        if (deletedStatus == 'failed' && submitted) {
            setErrorModal(true);
            setErrorBody('There was an issue deleting the booking. Please try again. ' + deleteError)
        }
    }, [deletedStatus]);

    // patch status listener
    useEffect(() => {
        // complete
        if (patchStatus === 'succeeded' && submitted) {
            setLoading(false)
            // close scanner
            setSuccessModal(true);
        }
        if (patchStatus == 'loading' && submitted) {
            setLoading(true)
        }
        if (patchStatus == 'failed' && submitted) {
            setErrorModal(true);
            setErrorBody('There was an issue confirming the booking. Please try again. ' + patchError)
        }
    }, [patchStatus]);

    // create booking listener
    useEffect(() => {
        // complete
        if (bookingStatus === 'succeeded' && submitted) {
            setLoading(false)
            setShowBooking(true);
        }
        if (bookingStatus == 'loading' && submitted) {
            setLoading(true)
        }
        if (bookingStatus == 'failed' && submitted) {
            console.log(bookingError, "bookingErrorbookingErrorbookingError");
            setErrorModal(true);
            setErrorBody('There was an issue creating the booking. Please try again. ' + bookingError)
        }
    }, [bookingStatus]);

    // Check for camera permissions
    useEffect(() => {
        navigator.permissions.query({ name: 'camera' })
            .then((permissionObj) => {
                if (permissionObj.state === 'granted') {
                    setHasPermission(true);
                } else if (permissionObj.state === 'prompt') {
                    askForCameraPermission();
                } else {
                    setErrorMessage('Camera access denied. Please enable camera permissions to use this feature.');
                }
            })
            .catch((error) => {
                console.error('Permission not found', error);
                setErrorMessage('Error checking camera permissions.');
            });
    }, []);

    useEffect(() => {
        dispatch(resetScanFlags())
    }, []);

    //#region functions

    const handleComplete = () => {
        setSuccessModal(false);
        setDeletedModal(false);
        handleGoBack();
    }

    const handleGoBack = () => {
        const previousRoute = location.state?.from || '/timeline-view';
        history.push(previousRoute);
    }

    const handleDelete = () => {
        console.log('deleting booking', scannedBooking)
        dispatch(deleteBooking(scannedBooking.id))
    }

    const confirmBooking = () => {
        let copy = {};

        // check if flight info is present
        console.log('scanned booking', scannedBooking);
        if (scannedBooking.flightConfirmationDetails && scannedBooking.flightConfirmationDetails.departureTime == "") {
            // need to add flight info, it was not retrieved from sita correctly hwen creatin the booking
            let currentTime = new Date().toISOString();
            let newConfirmationDetails = { ...scannedBooking.flightConfirmationDetails, departureTime: currentTime, arrivalTime: currentTime };
            copy = { ...scannedBooking, status: 'user-confirmed', flightConfirmationDetails: newConfirmationDetails };
        }
        else {
            copy = { ...scannedBooking, status: 'user-confirmed' };
        }
        console.log('patched booking ', copy)
        dispatch(patchBooking(copy))
    }

    // Function to request camera access
    const askForCameraPermission = () => {
        navigator.mediaDevices.getUserMedia({ video: true })
            .then((stream) => {
                stream.getTracks().forEach(track => track.stop()); // stop the stream so it doesn't stay on
                setHasPermission(true);
            })
            .catch((error) => {
                console.error('Error accessing camera', error);
                setErrorMessage('Access to camera was denied.');
            });
    };

    function convertJulianDate(julianDate, year) {
        // Parse the year and Julian date
        let date = new Date(year, 0); // Initialize date at the start of the year
        date.setDate(julianDate); // Set the date to the Julian day

        // Format the date as YYYY-MM-DD
        let day = String(date.getDate()).padStart(2, '0');
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }

    function convertName(name) {
        // Split the name by the '/'
        let parts = name.split('/');
        if (parts.length !== 2) {
            throw new Error('Invalid name format');
        }
        let lastName = parts[0];
        let firstName = parts[1];

        // Capitalize the first letter of each name part
        lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
        firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();

        // Combine the parts into a readable string
        return `${firstName} ${lastName}`;
    }

    function parseFlightBarcode(barcode) {
        let flightDetails = {};

        flightDetails.formatCode = barcode.substring(0, 1);
        flightDetails.numberOfLegs = barcode.substring(1, 2);
        flightDetails.passengerName = barcode.substring(2, 22).trim();
        flightDetails.eTicketIndicator = barcode.substring(22, 23);
        flightDetails.operatingCarrierPNR = barcode.substring(23, 30).trim();
        flightDetails.fromCityCode = barcode.substring(30, 33);
        flightDetails.toCityCode = barcode.substring(33, 36);
        flightDetails.operatingCarrierDesignator = barcode.substring(36, 39);
        flightDetails.flightNumber = barcode.substring(39, 43).trim();
        flightDetails.dateOfFlight = barcode.substring(43, 46);
        flightDetails.compartmentCode = barcode.substring(46, 47);
        flightDetails.seatNumber = barcode.substring(47, 51).trim();
        flightDetails.checkInSequenceNumber = barcode.substring(51, 56);
        flightDetails.passengerStatus = barcode.substring(56, 57);
        flightDetails.fieldSize = barcode.substring(57, 59);

        // Extract the optional variable size fields if present
        let variableFieldsStart = 59;
        let variableFieldsLength = parseInt(flightDetails.fieldSize, 10);
        if (!isNaN(variableFieldsLength) && variableFieldsLength > 0) {
            flightDetails.variableFields = barcode.substring(variableFieldsStart, variableFieldsStart + variableFieldsLength);
        } else {
            flightDetails.variableFields = '';
        }

        let formattedResponse = {
            'flightDate': convertJulianDate(parseInt(flightDetails.dateOfFlight, 10), new Date().getFullYear()),
            'flightNumber': flightDetails.flightNumber,
            'carrierCode': flightDetails.operatingCarrierDesignator,
            'passengerName': convertName(flightDetails.passengerName),
            'origin': flightDetails.fromCityCode,
            'destination': flightDetails.toCityCode,
            'seatNumber': flightDetails.seatNumber,
        }

        return formattedResponse;
    }

    const createBookingFromBarcode = (flightDetails) => {
        return {
            name: flightDetails.passengerName,
            flightDetails: {
                carrierCode: flightDetails.carrierCode,
                flightNumber: flightDetails.flightNumber,
                origin: flightDetails.origin,
                destination: flightDetails.destination,
                departureDate: flightDetails.flightDate,
            },
            seatNumber: flightDetails.seatNumber,
            assistance: ['WCHR'],
            referenceNumber: "N/A",
            dueTime: "N/A",
            bio: "N/A",
            destinationAssistance: true,
            originAssistance: true,
            equipment: false,
            airlineConfirmed: true,
            portal: iata,
            manualInput: false,
            serviceAnimal: false,
            userId: "12345",
            iata: iata,
            isConnectBooking: false
        };
    }

    const handleScan = (result) => {
        // console.log('result', result)
        let string = result.text;

        if (string) {
            let val = parseFlightBarcode(string);

            // check for valid scan
            if (val.flightDate && val.flightNumber && val.passengerName && val.origin && val.destination && val.seatNumber) {
                // pause scanner
                setStreamToggle(true)

                console.log('getting booking doc...')

                // create booking using flight info
                let bookingDoc = createBookingFromBarcode(val);

                if (bookingDoc) {
                    // create booking w/ flight info
                    setSubmitted(true)
                    dispatch(createBooking(bookingDoc))
                }
                else {
                    setBarcodeError('Issue creating flight info from barcode. Please try again.')
                    setStreamToggle(false)
                }

                console.log('booking : ', bookingDoc)

            } else {
                console.log('Invalid scan. Please try again.');
            }
        }
    }

    //#endregion

    return (
        <div style={{ justifyContent: 'center', display: 'flex' }}>

            {/* show scanned booking card */}
            {showBooking && scannedBooking &&
                <div className='mt-3' style={{ width: 800, height: 800, borderRadius: 25 }}>

                    {/* spacer */}
                    <div className='mt-5' />
                    <TremorTitle>Confirm Booking</TremorTitle>
                    <Subtitle>Review the information on the booking before confirming the booking</Subtitle>

                    <Row className='mt-2'>
                        <FormBookingCard bookings={[scannedBooking]} />
                    </Row>

                    <Row className='mt-5'>
                        <Flex>
                            <Button variant='outline-danger' disabled={deletedStatus == 'succeeded' ? true : false} onClick={handleDelete}>{'Cancel Booking'}</Button>
                            <Button variant='outline-success' disabled={bookingStatus == 'succeeded' ? false : true} onClick={confirmBooking}>{'Confirm Booking'}</Button>
                        </Flex>
                        {
                            patchError && (
                                <p className='text-danger mt-2' style={{ color: Colors.TEXT_COLOR }}>{patchError == null ? '' : patchError}</p>)
                        }
                    </Row>
                </div>
            }

            {/* show barcode scanner */}
            {hasPermission && !showBooking &&
                <div className='mt-3' style={{ width: 800, height: 800, borderRadius: 25 }}>

                    {/* spacer */}
                    <div className='mt-5' />

                    {/* text */}
                    <div style={{ borderRadius: 10, backgroundColor: Colors.PRM_LIGHT_BLUE, width: 400, height: 80, display: 'flex', marginLeft: '25%', justifyContent: 'space-between' }}>
                        <MdQrCode2
                            style={{ marginLeft: 12, marginTop: 8 }}
                            color={"white"}
                            size={60}
                        />
                        <h3 className='mt-4' style={{ color: 'white', marginLeft: 12 }}>Scan Boarding Pass</h3>
                        <IoCloseCircle onClick={handleGoBack} style={{ cursor: 'pointer', marginRight: 12, marginTop: 8 }} color={'white'} size={32} />
                    </div>

                    {/* blue outline */}
                    <div style={{ borderRadius: 10, borderWidth: 5, borderStyle: 'solid', borderColor: Colors.PRM_LIGHT_BLUE, zIndex: 1, opacity: 1.0, width: 400, height: 350, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />

                    {/* loading spinner */}
                    {loading &&
                        <div style={{ width: 50, height: 50, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                            <CustomSpinner />
                        </div>
                    }

                    {/* camera */}
                    <div className='mt-2' style={{ borderRadius: 10, borderWidth: 2.5, borderStyle: 'solid', borderColor: 'black', }}>
                        <BarcodeScannerComponent
                            width={'100%'}
                            height={'100%'}
                            onUpdate={(err, result) => { if (result) { handleScan(result) }; }}
                            stopStream={streamToggle}
                        />
                    </div>
                    <p>{barcodeError ? barcodeError : ""}</p>
                </div>
            }

            {/* need permission */}
            {!hasPermission &&
                <div className='mt-3' style={{ width: 800, height: 800, borderRadius: 25 }}>
                    <TremorTitle>Camera Permission Required</TremorTitle>
                    <Subtitle>In order to scan boarding passes PRM Assist requires permission to use your devices camera, please click 'Allow' to enable the camera and scan boarding passes</Subtitle>
                    <Button variant='outline-primary' className='mt-3' onClick={askForCameraPermission}>Request Camera Permission</Button>
                </div>
            }

            {/* success modal */}
            <CustomModal
                hide={handleComplete}
                show={successModal}
                title={'Success'}
                body={'The booking has been successfully created'}
                button={'Done'}
                openButton={handleComplete}
            />

            {/* delete modal */}
            <CustomModal
                hide={handleComplete}
                show={deletedModal}
                title={'Deleted Booking'}
                body={'The booking has been deleted'}
                button={'Done'}
                openButton={handleComplete}
            />

            {/* error modal */}
            <CustomModal
                hide={handleComplete}
                show={errorModal}
                title={'Error'}
                body={errorBody}
                button={'Done'}
                openButton={handleComplete}
            />

        </div>
    );
};

export default FlightScanner;
